/*
 * ===============================================================================================================
 *                                Copyright 2023, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import { useSelector } from 'react-redux';
import { Box, Typography, Alert } from '@mui/material';
import EmptyComponent from '../../../shared/EmptyComponent/EmptyComponent';
import { selectModuleById } from '../../../store/role/GlobalRole/globalRoleSelector';
import { useStyles } from './styles';
import { EMPTY_SCREEN_ALERT, MODULE_LABEL, NO_BUILTIN_POLICIES_ADDED } from './constants';
import { ADD_BUILTIN_POLICIES } from '../constants';

interface EmptyScreenProps {
  disableCreateAction?: boolean;
  openAddBuiltinPoliciesDialog: () => void;
  moduleId: number | undefined;
}

const EmptyScreen = ({ disableCreateAction = false, openAddBuiltinPoliciesDialog, moduleId }: EmptyScreenProps) => {
  const module = useSelector((state: any) => selectModuleById(state, moduleId));

  const { classes } = useStyles();

  return (
    <Box className={classes.root}>
      <Alert severity="info" variant="outlined">
        {EMPTY_SCREEN_ALERT}
      </Alert>
      {module && (
        <Typography className={classes.moduleInfo}>
          {MODULE_LABEL}
          {' - '}
          <Typography component="span" className={classes.moduleName}>
            {module.name}
          </Typography>
        </Typography>
      )}
      <EmptyComponent
        text={NO_BUILTIN_POLICIES_ADDED}
        title=""
        primaryButtonText={ADD_BUILTIN_POLICIES}
        handleOnCreateAction={openAddBuiltinPoliciesDialog}
        disableCreateAction={disableCreateAction}
      />
    </Box>
  );
};

export default EmptyScreen;
